const Monaco = {
  flex: 1,
  position: 'relative',
  foldLevel: 2,
  opacity: 1,
  height: '100%',
  width: '100%',
  beautify: true,
  debounceDuration: 350,
  data: {},
  fileTab: {
    code: 'export default {}',
    type: 'javascript',
    filename: 'app.js',
    fileTabKey: 'unique-key'
  },
  onCodeEditCallback: (editor, _2, el) => {
    el.log(editor.getValue())
  },
  onRender: async (el, s) => {
    const { StandaloneMonaco } = await import('@symbo.ls/monaco')
    await StandaloneMonaco.onRender(el, s)
  },
  onBeforeUpdate: async (_, el, s, ctx, opts) => {
    const { StandaloneMonaco } = await import('@symbo.ls/monaco')
    return StandaloneMonaco.onBeforeUpdate(_, el, s, ctx, opts)
  }
}

export const CodePreviewWidget = {
  display: 'flex',

  flow: 'column',
  position: 'sticky',
  top: '0',
  order: 0,
  widthRange: 'H1',

  Flex_tabs: {},

  Monaco
}
